module.exports = __webpack_public_path__ + "static/media/Vela - DK Grey_White.e5e666a7.jpg";